module.exports = __webpack_public_path__ + "img/KH.e80b6096.webp";